import { Component } from '@angular/core';
import { DialogComponent } from '@app/shared/dialog/dialog-component.directive';
import { SharedModule } from '@app/shared/shared.module';
import { NotificationLiveViewComponent } from '@business/notification/components/notification-live-view/notification-live-view.component';
import { SupportedPortalNotification } from '@business/notification/models/portal-notification-helpers';

interface ReleaseNotesDialogInput {
  /**
   * Default is the current language
   */
  language?: string;
  notifications: SupportedPortalNotification[];
}

@Component({
  selector: 'portal-notification-dialog',
  standalone: true,
  imports: [SharedModule, NotificationLiveViewComponent],
  templateUrl: './release-notes-dialog.component.html',
  styleUrls: ['./release-notes-dialog.component.scss'],
})
export class ReleaseNotesDialogComponent
  extends DialogComponent<ReleaseNotesDialogInput, void>
  implements ReleaseNotesDialogInput
{
  readonly language?: string;
  readonly notifications!: SupportedPortalNotification[];
}
